/**
 * `/settings/seller` — the seller profile.
 *
 * Lives under /settings rather than under /market because it is a property of
 * the ACCOUNT, not a page of the storefront: one seller identity per account,
 * shared by the packs you publish and the engagements you take.
 *
 * BUILD GATE: either marketplace master may include this shared identity
 * screen. Runtime child access still comes only from the authenticated
 * gateway capability DTO in seller.lazy.tsx.
 */
import { createFileRoute, redirect } from '@tanstack/react-router';

import { env } from '../../../env';

export const Route = createFileRoute('/_authenticated/settings/seller')({
  beforeLoad: () => {
    if (!(env.VITE_MARKETPLACE || env.VITE_SKILLS_STORE)) {
      throw redirect({ to: '/' });
    }
  },
});
